export const setDateTime = (date, type) => ({
    type: 'SET_DATETIME',
    payload: { date, type }
});